export default __webpack_public_path__ + "images/loggedout/home/dweb-homepage-splashee@2x-45849fe39d93c4687b36c31a9c6ed472.png";